<template>
    <span>{{ value ? $tools.formatTime(value, format || 'YYYY-MM-DD') : placeholder || '--' }}</span>
</template>

<script>
export default {
    name: 'formatDatetime',
    props: ['value', 'scope', 'format', 'placeholder']
};
</script>
